import { PRODUCT_DIRECTORY, WAREHOUSES } from '@app/constants';
import type { NNavigation } from '@app/types';

interface FilterWarehouseChildrenOptions {
  canViewWarehouse: boolean;
  canViewProducts: boolean;
}

// Сайдбар фильтрует по правам только пункты верхнего уровня, servicerightsid
// у дочерних пунктов не учитывается. «Справочник товаров» раньше был в
// настройках и виден только при Products.IsOn — сохраняем это правило.
// Остальные пункты раздела требуют Warehouse.IsOn: без него раздел
// показывается только ради справочника.
export const filterWarehouseChildren = (
  items: NNavigation.NavigationAllItems[],
  { canViewWarehouse, canViewProducts }: FilterWarehouseChildrenOptions
): NNavigation.NavigationAllItems[] => {
  if (canViewWarehouse && canViewProducts) return items;

  return items.map((item) => {
    if (item.id !== WAREHOUSES || !item.children) return item;

    const children = item.children as NNavigation.NavigationAllItems[];

    return {
      ...item,
      children: children.filter(({ id }) =>
        id === PRODUCT_DIRECTORY ? canViewProducts : canViewWarehouse
      ),
    };
  });
};
